import { render, staticRenderFns } from "./ByInsured.vue?vue&type=template&id=9b03d73c&"
import script from "./ByInsured.vue?vue&type=script&lang=js&"
export * from "./ByInsured.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports